import type { CoworkAccountingSummary } from "./api"

export function shouldShowAccountingMode(summary: CoworkAccountingSummary | undefined) {
  return summary?.accounting_enabled === true
}
